import { Button, Text, Flex } from "@chakra-ui/react";

interface TicketInputRightSectionProps {
  onClick(): void;
  token: {
    balance: number;
    symbol: string;
  };
  maxCTA?: string;
  inputBalanceCTA?: string;
}

const TicketInputRightSection = ({
  onClick,
  token,
  maxCTA,
  inputBalanceCTA,
}: TicketInputRightSectionProps) => {
  return (
    <Flex flexDir="column" alignItems="flex-end">
      {maxCTA ? (
        <Button
          bg="seperator"
          h="1.5rem"
          size="sm"
          p={1}
          color="textPrimary"
          _light={{
            color: "primary",
          }}
          _hover={{
            color: "white",
            outline: "none",
            border: "1px solid",
            borderColor: "primary",
          }}
          _focus={{
            outline: "none",
          }}
          onClick={onClick}
          w="41px"
          fontWeight="700"
          fontSize="10px"
        >
          {maxCTA}
        </Button>
      ) : null}

      {token?.balance && inputBalanceCTA ? (
        <Text fontWeight="400" fontSize="12px" mt="1rem">
          Balance: {token.balance} {token.symbol}
        </Text>
      ) : null}
    </Flex>
  );
};

export default TicketInputRightSection;
